import { createSlice } from '@reduxjs/toolkit';
import { getEventsByType, getAllEvents } from './services';
import initialState from './initialState';

export const RightbarSlice = createSlice({
  name: 'Rightbar',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get events by type (separated)
      .addCase(getEventsByType.pending, (state) => {
        state.calendarEvents.loading = true;
      })
      .addCase(getEventsByType.fulfilled, (state, action) => {
        state.calendarEvents.loading = false;

        const { events_without_visits, events_with_visits } = action.payload;

        state.calendarEvents.eventsWithoutVisits = events_without_visits.events;
        state.calendarEvents.eventsWithVisits = events_with_visits.events;
      });

    builder
      // Get all events (unified)
      .addCase(getAllEvents.pending, (state) => {
        state.calendarEvents.loading = true;
      })
      .addCase(getAllEvents.fulfilled, (state, action) => {
        state.calendarEvents.loading = false;

        const { events } = action.payload;

        state.calendarEvents.allEvents = events;
      });
  },
});

export default RightbarSlice.reducer;
